/** Query na URL de retorno do Stripe (alinhado ao backend `CHECKOUT_SUCCESS_PAYMENT_ID_PARAM`). */
export const VERIFY_SUBSCRIPTION_PAYMENT_ID_QUERY = 'payment_id';

/** Após aprovação, aguarda antes de ir ao app (UX). */
export const VERIFY_SUBSCRIPTION_SUCCESS_REDIRECT_MS = 2000;
